import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';


import { AgGridModule } from 'ag-grid-angular';

import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChangeinComplianceOfficerFormComponent } from './changein-compliance-officer-form/changein-compliance-officer-form.component';
import { ReportComponent } from './report/report.component';
import { NismCertificateReportComponent } from './nism-report/nism-certificate-report.component';




@NgModule({
  declarations: [

    ChangeinComplianceOfficerFormComponent,
    ReportComponent,
    NismCertificateReportComponent,
   

    //<--------- System Audit --------->


    //System Audit

    
    // Internal Audit
    
    //annual Return
    
    // ChangeInClearingMemberComponent,

    //Global Access for Annual Return 
    
    // <------------ P2P Connectivity ------------>
  
    //Cyber Audit
   
    //Authorised Person
    
    //Surrender Submission
    
    /////AuditTrailComponent
    

    //Pro-Enablement
    
    //NNF
   
    //LES
    
    //QuartelyRegReport
    

    //PN3
   



    //Change in director
    

    //Penalty Calculations
    

    //Change in shareHolding
    

    //BMC

    //Change in Member Details
    

    // Issuance of Report
    
    //multi Locking removal
   
    // MIS Dashboard
   

    //first trade certificate
    
    //Ip Surrender
    

    //Annual Compliance Audit 
    


  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class ChangeComplianceOfficerModule { }
